import { setWasmUrl } from '@lottiefiles/dotlottie-react';
import dotlottieWasmUrl from '@lottiefiles/dotlottie-web/dist/dotlottie-player.wasm?url';

// Serve the dotlottie-web renderer WASM from our own origin instead of the
// library's default jsdelivr CDN (with unpkg backup). The `?url` suffix makes
// each consuming app's Vite build emit a fingerprinted same-origin asset.
// setWasmUrl writes the library's global _wasmURL static, so one call covers
// every animation in the app.
setWasmUrl(dotlottieWasmUrl);
